import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Catalogs|Exam|Related Credentials|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Credential,
	portal: 'SP',
};

type LocNameStart = 'SPExamCatalogRelatedCerts';
export type SPExamCatalogRelatedCertsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelFilterByStatus`;

export const spExamCatalogRelatedCertsLocs: LocDefs<SPExamCatalogRelatedCertsLocNames> = {
	SPExamCatalogRelatedCertsTitlePage: {
		defaultValue: 'Related Credentials',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Exam/Catalogs.Exams.Title.RelatedCertsPage',
		...sharedProperties,
	},
	SPExamCatalogRelatedCertsTitleTab: {
		defaultValue: 'Exam Related Credentials',
		description: 'Tab Title',
		displayPath: `${pathStart}Tab Title`,
		displayType: 'Title',
		legacyName: 'Exam/Catalogs.Exams.Title.RelatedCertsTab',
		...sharedProperties,
	},
	SPExamCatalogRelatedCertsLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'Exam/Catalogs.Exams.ColumnHeading.RelatedCertsName',
		...sharedProperties,
	},
	SPExamCatalogRelatedCertsLabelStatus: {
		defaultValue: 'Status',
		description: 'Column heading for: Status.',
		displayPath: `${pathStart}Status`,
		displayType: 'Label',
		legacyName: 'Exam/Catalogs.Exams.ColumnHeading.RelatedCertsStatus',
		...sharedProperties,
	},
	SPExamCatalogRelatedCertsLabelFilterByStatus: {
		defaultValue: 'Filter by Status',
		description: 'Label for: Filter by Status.',
		displayPath: `${pathStart}Filter by Status`,
		displayType: 'Label',
		legacyName: 'Exam/Catalogs.Exams.FieldLabel.RelatedCertsFilterByStatus',
		...sharedProperties,
	},
};

export type SPExamCatalogRelatedCertsLocType = LocMap<SPExamCatalogRelatedCertsLocNames>;
